var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":_vm.clicked}}),_c('v-container',{staticClass:"px-0 px-sm-3 my-16"},[_c('ProposalCustomGrid',{attrs:{"title":_vm.$t('headerBanner.title'),"proposals":_vm.headerBanner,"showProposalContent":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }